import { Layout, Typography } from '@sonnen/web-ui';
import { parseHtmlTags } from '@sonnen/web-utils';
import { useEffect } from 'react';
import { useAppContext } from '../../AppContext/AppContext';
import { LocaleKey, useTranslation } from '../../i18n/i18n';
import { OrderFlow, PageBackground } from '../../types';
import { CheckAnimation } from './CheckAnimation/CheckAnimation';
import styles from './Confirmation.module.css';
import FAQList from './FAQList/FAQList';

export const Confirmation = () => {
  const { t } = useTranslation();
  const { orderFlow, formValues, setCurrentBackground } = useAppContext();

  const messageKey: LocaleKey = `confirmation.${orderFlow!}.message`;
  const title: LocaleKey = `confirmation.${orderFlow!}.title`;

  const message = parseHtmlTags(
    t(messageKey, {
      email: formValues.personalData.email,
    }),
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    setCurrentBackground(PageBackground.CONFIRMATION);
  }, []);

  return (
    <div className={styles.confirmationPage} data-testid="order-complete">
      <Layout centerContent centerVertically backgroundColor="none" fullViewportHeight>
        <div className={styles.animationSection}>
          <CheckAnimation />

          <div className={styles.confirmationText}>
            <Typography.H1 variant="on-colour">{t(title)}</Typography.H1>
            <Typography.Body1 variant="on-colour">{message}</Typography.Body1>
          </div>
        </div>

        {orderFlow !== OrderFlow.selfConsumptionPlus && <FAQList />}
      </Layout>
    </div>
  );
};
